import {Base} from "@/api/Base"

export class SalaryCheckSalary extends Base {
    path = "salary/checkSalary"
}